import { useRef, useState } from "react";
import { useInfiniteShorts } from "../../hooks/useGetShorts";
import ShortCard from "../../pages/video-pages/ShortCard";
import ShortsPlayer from "../../components/shorts/ShortsPlayer";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Mousewheel, FreeMode } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import styles from "./Css/ShortsCarosel.module.css";

const ShortsCarousel = () => {
  const swiperRef = useRef(null);
  const [showPlayer, setShowPlayer] = useState(false);
  const [selectedShortId, setSelectedShortId] = useState(null);

  const { shorts, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useInfiniteShorts(10);

  const handleSlideChange = (swiper) => {
    if (swiper.isEnd && hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  };

  const handleShortClick = (shortId) => {
    setSelectedShortId(shortId);
    setShowPlayer(true);
  };

  const handleClosePlayer = () => {
    setShowPlayer(false);
  };

  const EnhancedShortCard = ({ short }) => (
    <div onClick={() => handleShortClick(short.id)}>
      <ShortCard short={short} />
    </div>
  );

  if (!shorts || shorts.length <= 4) {
    return null;
  }

  return (
    <div className={styles.shortsContainer}>
      {!showPlayer ? (
        <>
          <h2 className={styles.title}>Shorts</h2>
          <div className={styles.shortsWrapper}>
            <Swiper
              freeMode={{
                enabled: true,
                momentum: true,
                momentumRatio: 0.8,
                momentumVelocityRatio: 0.8,
                minimumVelocity: 0.02,
              }}
              modules={[Mousewheel, FreeMode, Navigation]}
              mousewheel={{
                forceToAxis: true,
                sensitivity: 1.5,
                releaseOnEdges: true,
              }}
              speed={600}
              resistance={false}
              resistanceRatio={0}
              navigation={{
                prevEl: ".shorts-prev-btn",
                nextEl: ".shorts-next-btn",
              }}
              spaceBetween={10}
              slidesPerView="auto"
              className={styles.swiper}
              breakpoints={{
                320: { slidesPerView: 2.5 },
                480: { slidesPerView: 3 },
                768: { slidesPerView: 3 },
                1024: { slidesPerView: 4 },
                1200: { slidesPerView: 5 },
                1440: { slidesPerView: 5 },
              }}
              onSlideChange={handleSlideChange}
              ref={swiperRef}
            >
              {shorts.map((short) => (
                <SwiperSlide key={short.id}>
                  <EnhancedShortCard short={short} />
                </SwiperSlide>
              ))}
              {isFetchingNextPage && (
                <SwiperSlide>
                  <div className={styles.loadingSlide}>Loading more...</div>
                </SwiperSlide>
              )}
            </Swiper>

            <button
              className={`${styles.navButton} ${styles.prevButton} shorts-prev-btn`}
            >
              <span className={styles.navArrow}>‹</span>
            </button>
            <button
              className={`${styles.navButton} ${styles.nextButton} shorts-next-btn`}
            >
              <span className={styles.navArrow}>›</span>
            </button>
          </div>
        </>
      ) : (
        <div className={styles.playerWrapper}>
          <button
            className={styles.closePlayerButton}
            onClick={handleClosePlayer}
            aria-label="Close player"
          >
            &times;
          </button>
          <ShortsPlayer initialShortId={selectedShortId} />
        </div>
      )}
    </div>
  );
};

export default ShortsCarousel;
